import React from 'react';

const ML_Clustering = () => {
    return (
        <div>ML_Clustering Component</div>
    );
}

export default ML_Clustering;
